











































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import MarkdownIt from 'markdown-it';
import { SendPacket } from '@/networking/SendPacket';
import { PacketType } from '@/models/Packet';
import Timeline from '@/models/Timeline';
import Node from '@/models/Node';
import Mutations from '@/store/mutations';
import Tag from '@/models/Tag';
import TagCircle from '@/views/timelineeditor/tagui/TagCircle.vue';
import KeyListener from '@/KeyListener';

@Component({
    components: {
        TagCircle
    },
	computed: {
		...mapGetters([
            
		])
    },
    recomputed: {
        
    }
})
export default class FullEventSlide extends Vue {
    forceUpdateImgUrl = false;

    autoplaying = false;
    defaultAutoplayCounter = 20; // set this to change the default duration for a autoplayed slide
    startAutoplayCounter = this.defaultAutoplayCounter; // used by the radial timer to know percent
    autoplayCounter = this.defaultAutoplayCounter; // current count
    timer = <NodeJS.Timeout><unknown>null;
    md = new MarkdownIt();

    renderMarkdown(text: string)
    {
        return this.md.render(text
            // pre-process
            .replace(/\<(?!\w*\:\/\/)([^\s]+\.[^\s]+)\>/g, '<https://$1>') // all links are absolute
        )
            // post-process
            .replace(/<a[ >]/g, '<a target="_blank" ') // all links target new tab/window
            .replace(/href="((?!\w+\:\/\/)[^"]+)"/g, 'href="https://$1"') // all links are absolute
            .replace(/<img[ >]/g, '<img style="max-width: 80%; max-height: 200vh; object-fit: contains;" '); // resize images
    }

    get event() : Node
	{
		return this.$store.getters.nodes.get(this.$store.state.project.presentationFullSlide);
    }

    get eventTag() : Tag | null
    {
        return this.event.tags.length == 0 ? null : this.event.tags[0];
    }

    get timeline() : Timeline
	{
		return this.$store.state.project.activeTimeline;
    }

    get isNodeImageValid() 
    {
        return this.event.image.trim() != '';
    }

    get loadedImage() {
        console.log("LOADING");
        let img = new Image();
        img.src = this.rawImageUrl;
        if (!img.complete)
        {
            console.log("Image not cached");
            img.onload = () =>
            {
                console.log('Image fully loaded');
                this.forceUpdateImgUrl = !this.forceUpdateImgUrl;
            }
        }
        return img;
    }

    get rawImageUrl()
    {
        if (this.event.image.trim() == '')
        {
            return '/images/placeholder_img.png'
        }
        return this.event.image;
    }

    get isImageLoaded()
    {
        if (this.forceUpdateImgUrl && !this.forceUpdateImgUrl){console.log('update!');}
        return this.loadedImage.complete;
    }

    get imageUrl()
    {
        this.forceUpdateImgUrl;
        let rawURL = this.rawImageUrl;
        return rawURL;
    }

    mounted()
    {
        KeyListener.addKeyHandler(this);
       	setTimeout(() => {
            this.$nextTick(() =>
            {
                this.$nextTick(() =>
                {
                    const name = this.$refs.eventName as any;
                    console.log(name);
                    if (name) name.focus();
                });
            });
        }, 50);
        
        this.resetAudioAndAutoplayCounter();
    }

    beforeDestroy()
    {
        KeyListener.removeKeyHandler(this);
    }

    keyHandler(_event : Event, isTextBoxFocused : boolean)
    {
        if (!isTextBoxFocused)
        {
            if (KeyListener.isPeriodDown())
            {
                this.next();
            }
            else if (KeyListener.isCommaDown())
            {
                this.previous();
            }
        }
    }
    
    previous()
    {
        // get the previous nodeid from timeline.getEventOrdering()
        let ordering = this.timeline.getEventOrdering();
        let index = ordering.indexOf(this.event.nodeid);
        index = ((index - 1) >= 0) ? (index - 1) : ordering.length - 1;
        this.$store.commit(Mutations.setPresentationFullSlide, ordering[index]);
        this.resetAudioAndAutoplayCounter();
    }

    collapse()
    {
        // close this, open equivalent MiniEventSlide
        if (this.autoplaying)
        {
            this.toggleAutoplay();
        }
        this.autoplayCounter = this.startAutoplayCounter;
        let n = this.$store.getters.nodes.get(this.$store.state.project.presentationFullSlide);
        if (n != null && n.component != null)
        {
            n.component.onNodeClick(null, true);
        }
        this.$store.commit(Mutations.setPresentationFullSlide, -1);
    }

    next()
    {
        // get the next nodeid from timeline.getEventOrdering()
        let ordering = this.timeline.getEventOrdering();
        let index = ordering.indexOf(this.event.nodeid);
        index = ((index + 1) < ordering.length) ? (index + 1) : 0;
        this.$store.commit(Mutations.setPresentationFullSlide, ordering[index]);
        this.resetAudioAndAutoplayCounter();
    }

    resetAudioAndAutoplayCounter()
    {
        this.startAutoplayCounter = this.defaultAutoplayCounter;
        this.autoplayCounter = this.startAutoplayCounter;
        setTimeout(() =>
        {
            if (this.$refs.audioPlayer != null)
            {
                (this.$refs.audioPlayer as any).load();
                if (this.autoplaying)
                {
                    (this.$refs.audioPlayer as any).onloadeddata = () =>
                    {
                        (this.$refs.audioPlayer as any).play();
                    }
                }
                else
                {
                    (this.$refs.audioPlayer as any).pause();
                }
            }
        }, 1);
    }

    setDefaultAutoplay()
    {
        if (this.startAutoplayCounter != this.defaultAutoplayCounter)
        {
            this.startAutoplayCounter = this.defaultAutoplayCounter;
            if (this.autoplayCounter > this.startAutoplayCounter)
            {
                this.autoplayCounter = this.startAutoplayCounter;
            }
        }
    }

    onLoadedAudioMetadata()
    {
        let d = (this.$refs.audioPlayer as any).duration;
        if (d != null)
        {
            d = Math.ceil(d);
            if (d > this.startAutoplayCounter)
            {
                this.startAutoplayCounter = d;
                this.autoplayCounter = this.startAutoplayCounter;
            }
        }
    }

    toggleAutoplay()
    {
        this.autoplaying = !(this.autoplaying);
        if (this.autoplaying)
        {
            if (this.timer != null)
            {
                clearInterval(this.timer);
                this.timer = <NodeJS.Timeout><unknown>null;
            }
            this.timer = setInterval(()=>{
                this.autoplayCounter -= 1;
                if (this.autoplayCounter === 0)
                {
                    this.$nextTick(() =>
                    {
                        this.next();
                    });
                }
            }, 1000);
            if (this.$refs.audioPlayer != null)
            {
                (this.$refs.audioPlayer as any).play();
            }
        }
        else
        {
            if (this.timer != null)
            {
                clearInterval(this.timer);
                this.timer = <NodeJS.Timeout><unknown>null;
            }
            if (this.$refs.audioPlayer != null)
            {
                (this.$refs.audioPlayer as any).pause();
            }
        }
    }

    customBlur(el : HTMLElement)
    {
        el.blur();
    }
}
